window.Modal = function(modalReference) {
  Modal.init(modalReference);
};

Modal.init = function(pageModal) {
  // Overlay check, add if not in DOM
  if (overlay.length === 0) {
    $('body').append('<div class="c-modalOverlay" id="modal-overlay"></div>');
    overlay = $('#modal-overlay');
  }
  var openBtnId = pageModal.attr('data-open-from');
  var openBtn = $('#' + openBtnId);
  openBtn.click(function () {
    console.log(pageModal);
    Modal.open(pageModal);
  });
}

Modal.close = function(pageModal) {
  pageModal.removeClass('modal-visible');
  overlay.removeClass('modal-visible');
  pageModal.focus();
}

Modal.open = function(pageModal) {
  var closeBtn = pageModal.find('#close-btn');
  pageModal.addClass('modal-visible');
  overlay.addClass('modal-visible');
  pageModal[0].setAttribute('tabindex', '0');
  pageModal.focus();
  
  closeBtn.click(function() {
    Modal.close(pageModal);
  });
  
  overlay.click(function() {
    Modal.close(pageModal);
  });
  
  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      Modal.close(pageModal)
    }
  });
}

var overlay = $('#modal-overlay');
var modalsOnPage = $('.c-modal');

modalsOnPage.each(function() {
  new Modal($(this));
});
